export enum CommunityFeature {
  profileBlock = 'profileBlock',
  commonFeed = 'commonFeed',
  imageBackground = 'imageBackground',
  sideNavigation = 'sideNavigation',
  openProfileLinksInSameWindow = 'openProfileLinksInSameWindow',
  profileBackgroundGradient = 'profileBackgroundGradient',
}
